interface LogoProps {
  className?: string;
}

export function GlobalBondsLogo({ className = "w-full h-full" }: LogoProps) {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 50 50"
      className={className}
    >
      <polygon 
        fill="currentColor" 
        points="31.7 21.2 29.9 19.4 22.9 26.3 20.2 23.6 18.3 25.4 22.9 30 31.7 21.2" 
      />
      <path 
        fill="currentColor" 
        d="M25.1,3.1h0S6.3,11.4,6.3,11.4h0v14.5c0,7.1,6.3,14.2,18.7,20.9h0s0,0,0,0c12.4-6.7,18.7-13.8,18.7-20.9v-14.4L25.1,3.1ZM8.9,13.2l16.1-7.2,16.1,7.2v12.7c0,5.9-5.2,11.7-15.8,17.7l-.3.2-.3-.2c-10.7-6.1-15.8-11.9-15.8-17.7,0,0,0-12.7,0-12.7Z" 
      />
    </svg>
  );
}